<div class="pagination">
    <div class="pagination-info">
        <div class="page-size-select" (click)="togglePageSize()">
            <span>{{ 'show' | translate }} {{ pageSize }}</span>
            <img src="assets/images/dropDownArrow.svg" alt="" class="page-size-arrow" />
            @if (pageSizeOpen) {
                <div class="page-size-menu">
                    @for (size of pageSizes; track size) {
                        <div
                            class="page-size-option"
                            [class.is-selected]="size === pageSize"
                            (click)="onPageSizeSelect(size); $event.stopPropagation()"
                        >
                            {{ size }}
                        </div>
                    }
                </div>
            }
        </div>
        <span class="pagination-summary">
            {{ 'showing' | translate }} {{ rangeFrom }}-{{ rangeTo }} {{ 'outOf' | translate }} {{ total }}
        </span>
    </div>

    <div class="pagination-pages">
        <button
            type="button"
            class="page-btn"
            [disabled]="page <= 1"
            (click)="goTo(page - 1)"
            aria-label="Previous page"
        >
            ‹
        </button>

        @for (p of visiblePages; track $index) {
            @if (p === -1) {
                <span class="page-ellipsis">…</span>
            } @else {
                <button
                    type="button"
                    class="page-btn"
                    [class.is-active]="p === page"
                    (click)="goTo(p)"
                >
                    {{ p }}
                </button>
            }
        }

        <button
            type="button"
            class="page-btn"
            [disabled]="page >= totalPages"
            (click)="goTo(page + 1)"
            aria-label="Next page"
        >
            ›
        </button>
    </div>
</div>
